import React from 'react';
import T from 'prop-types';

import GELHeader from '@icare/react-kit/lib/components/Header';
import withAuth from '@icare/auth-okta/lib/withAuth';

import {sitePaths, accountPaths, authenticationPaths} from '~/paths';
import {MAIN_SITE_ROOT, APP_TITLE, FAQ_URL, CONTACT_US_TEL} from '~/config';
import injectContent from '@icare/sitecore-content/lib/injectContent';

@injectContent(['accessibilityLink', 'accountLink', 'contactUsLink', 'faqLink', 'homeLink'])
@withAuth
export default class Header extends React.Component {
	static propTypes = {
		auth: T.object.isRequired,
		content: T.object.isRequired,
	};

	static defaultProps = {};

	render() {
		const {content} = this.props;
		const {accessibilityLink, accountLink, contactUsLink, faqLink, homeLink} = content;
		const header = {
			links: [
				...(accessibilityLink.label
					? [
							{
								link: accessibilityLink.url || sitePaths.accessibilityPage,
								label: accessibilityLink.label,
								showAuth: [true, true],
								icon: '',
								mobileBar: false,
								mobileIcon: '',
								target: '',
							},
					  ]
					: []),
				...(faqLink.label
					? [
							{
								link: faqLink.url || FAQ_URL,
								label: faqLink.label,
								showAuth: [false, true],
								icon: '',
								mobileBar: false,
								mobileIcon: '',
								target: '',
							},
					  ]
					: []),
				...(contactUsLink.label
					? [
							{
								link: contactUsLink.url || `${MAIN_SITE_ROOT}${sitePaths.contactUsPage}`,
								label: contactUsLink.label,
								showAuth: [false, true],
								icon: '',
								mobileBar: true,
								mobileIcon: 'contact',
								target: '',
							},
					  ]
					: []),
				...(homeLink.label
					? [
							{
								link: homeLink.url || MAIN_SITE_ROOT,
								label: homeLink.label,
								showAuth: [false, true],
								icon: 'home',
								mobileBar: true,
								mobileIcon: 'home',
								target: '',
							},
					  ]
					: []),
				...(accountLink.label
					? [
							{
								link: accountLink.url || `${MAIN_SITE_ROOT}${accountPaths.detailsPage}`,
								label: accountLink.label,
								showAuth: [false, true],
								icon: 'Person',
								mobileBar: false,
								mobileIcon: 'Person',
								target: '',
							},
					  ]
					: []),
			],
			phone: {
				showAuth: [true, false],
				number: CONTACT_US_TEL,
			},
			login: {
				showAuth: [false, true],
				loginPath: authenticationPaths.login,
				logoutPath: authenticationPaths.logout,
			},
		};

		return (
			<GELHeader
				header={header}
				homePath={MAIN_SITE_ROOT}
				title={APP_TITLE}
				auth={this.props.auth}
			/>
		);
	}
}
